// Mirrors the API's assertCanStartSubscription: a seller Stripe is still billing
// must change plan through change-subscription rather than start a second one.
export default function hasLiveSubscription(seller) {
  return (
    Boolean(seller?.stripeSubscriptionId) &&
    ['active', 'past_due'].includes(seller?.subscriptionStatus) &&
    !seller?.stripeSubscriptionCancelAt
  );
}
